import { AdminProjectPlan, IntroductionDetails } from '@platform/client/schemas';
import {
  OrganizationProfileLink,
  ProfileItem,
  ProfileItemLong,
  ProfileLinkExternal,
  ProfileSection,
  ProfileTabContainer,
  ProjectProfileLink,
  ProUserProfileLink,
} from '../../components/ProfileComponents';
import { formatDateStr } from '../../../dashboard/my-projects/utils';
import { formatUserFirstLast } from '../../../util/TextHelpers';
import { ProjectPlanSection } from '../../components/ProjectPlanSection';

export const DetailsTabContent = ({
  introData,
  planData,
}: {
  introData?: IntroductionDetails | null;
  planData?: AdminProjectPlan | null;
}) => {
  return (
    <ProfileTabContainer>
      <ProfileSection title='Intro Details'>
        <OrganizationProfileLink
          organizationId={introData?.organization.id}
          organizationName={introData?.organization.name}
        />
        <ProUserProfileLink
          userId={introData?.professional.id}
          firstname={introData?.professional.firstName}
          lastname={introData?.professional.lastName}
        />
        <ProjectProfileLink
          projectId={introData?.project?.id}
          projectName={introData?.project?.name}
        />
        <ProfileItem label='Cohort' value={introData?.cohort?.name} />
        <ProfileItem
          label='Representative'
          value={formatUserFirstLast(
            introData?.representative?.firstName,
            introData?.representative?.lastName,
          )}
        />
        <ProfileItem label='Match Status' value={introData?.myProjectsStatus} />
        <ProfileItem label='Sent by' value={introData?.initiationType} />
        <ProfileItem
          label='Status Date'
          value={
            introData?.myProjectsStatusDate ?
              formatDateStr(introData?.myProjectsStatusDate)
            : undefined
          }
        />
        <ProfileItem
          label='Sent'
          value={introData?.createdAt ? formatDateStr(introData.createdAt) : undefined}
        />
        <ProfileLinkExternal label='Planning guide' href={introData?.planningGuideUrl} />
        <ProfileItemLong label='Message' value={introData?.message} />
      </ProfileSection>
      {planData && <ProjectPlanSection planData={planData} />}
    </ProfileTabContainer>
  );
};
